/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Pw_Billed_MonthlyInputs */

const en_funnel_pw_billed_monthly = /** @type {(inputs: Funnel_Pw_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billed monthly`)
};

const es_funnel_pw_billed_monthly = /** @type {(inputs: Funnel_Pw_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturado mensualmente`)
};

/**
* | output |
* | --- |
* | "Billed monthly" |
*
* @param {Funnel_Pw_Billed_MonthlyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_pw_billed_monthly = /** @type {((inputs?: Funnel_Pw_Billed_MonthlyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Pw_Billed_MonthlyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_pw_billed_monthly(inputs)
	return en_funnel_pw_billed_monthly(inputs)
});